import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import {usePreferenceContext} from 'src/context/PreferenceContext';
import {FruitStatusType} from 'src/views/harvesting/fruit-profile/model';
const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  tab: {
  }
});

interface TabWithNumberType {
  label: FruitStatusType,
  number: number,
  disableNumber?:boolean
}
const TabWithNumber:FC<TabWithNumberType> = ({label, number,disableNumber,...props}) => {
  const classes = useStyles();
  const {setFruitsTab}= usePreferenceContext();

  return (
    <Tab label={<>{label} {!disableNumber&&`(${number})`}</>} {...props} className={classes.tab} onClick={()=>setFruitsTab(label)}/>
  );
};

export default TabWithNumber;